import {
    defaultConfig,
    getDefaultConfig,
    mergedConfig,
    reconcileWin32HomeTabConfig,
    type MailRibbonConfigStore,
} from 'owa-mail-ribbon-store-shared-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function reconcileWin32MailRibbonConfiguration(
    ribbonConfig: MailRibbonConfigStore,
    isWin32StylingEnabled: boolean
): void {
    const standardDefault = isGlobalFeatureEnabled('cmp-ribbon-reorg')
        ? mergedConfig.get()
        : defaultConfig;
    const win32Default = getDefaultConfig(true, standardDefault);
    const sourceDefault = isWin32StylingEnabled ? standardDefault : win32Default;
    const targetDefault = isWin32StylingEnabled ? win32Default : standardDefault;

    ribbonConfig.singleline.homeTab = reconcileWin32HomeTabConfig(
        ribbonConfig.singleline.homeTab,
        sourceDefault.singleline.homeTab,
        targetDefault.singleline.homeTab
    );

    ribbonConfig.multiline.homeTab = reconcileWin32HomeTabConfig(
        ribbonConfig.multiline.homeTab,
        sourceDefault.multiline.homeTab,
        targetDefault.multiline.homeTab
    );
}
